import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo from '../../assets/icons/logo.svg';

const LoginLayout = ({ children }) => {
  return (
    <div className="main-wrapper">
      <Link to="/">
        <img
          className="px-7 w-60 h-20 border-r border-default-border flex-none cursor-pointer"
          src={logo}
          alt="Solmaz Express Logo"
        />
      </Link>
      <div className="main-content-login container flex m-auto w-screen h-70vh items-center justify-center">
        {children}
      </div>
    </div>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default LoginLayout;
